export default __webpack_public_path__ + "static/media/book3.221a6be6.svg";